let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a4HBr")).then(() => parcelRequire('fXUqn'));